import { ProductType } from '../impact-shop';

export enum IndirectlyAllocatedProject {
  GLOBAL_TREES = 'GLOBAL_TREES',
}

export enum ImpactFund {
  UK_CLIMATE_NATURE_FUND = 'UK_CLIMATE_NATURE_FUND',
  FORESTS_LANDSCAPES_FUND = 'FORESTS_LANDSCAPES_FUND',
  BAFTA_FUND = 'BAFTA_FUND',
  FLIGHTS_OFFSET_FUND = 'FLIGHTS_OFFSET_FUND',
}

export const ProjectMix = { ...IndirectlyAllocatedProject, ...ImpactFund };
export type ProjectMix = IndirectlyAllocatedProject | ImpactFund;

export const isImpactFundProjectMix = (projectMix: ProjectMix): projectMix is ImpactFund => {
  return Object.values(ImpactFund).includes(projectMix as ImpactFund);
};

export const isImpactFundProductType = (productType: ProductType): productType is ImpactFund => {
  return Object.values(ImpactFund).includes(productType as ImpactFund);
};
